module.exports = __webpack_public_path__ + "img/dahsing.b28e8f80.png";